module.exports = __webpack_public_path__ + "img/baia_logo.fb6288ad.jpg";